import type { IRoomData } from "./backend/nonauthenticated.generated.types";
import type { IBackendService } from "./backend";
import { USER_ROLES } from "./consts.generated";

export interface ICacheService {
    getRooms(): Promise<IRoomData[]>;
    getAllowedRooms(roles: string[]): Promise<IRoomData[]>;
}

export class CacheService implements ICacheService {

    private backend: IBackendService;
    private rooms: IRoomData[];
    private cache_loaded: boolean;

    constructor(backend: IBackendService) {
        this.backend = backend;
        this.cache_loaded = false;
        this.rooms = [];
    }

    public async getRooms(): Promise<IRoomData[]> {
        if (!this.cache_loaded) {
            this.rooms = (await this.backend.nonauthenticated().getOffices({})).rooms;
            this.cache_loaded = true;
        }
        return this.rooms;
    }

    public async getAllowedRooms(roles: string[]): Promise<IRoomData[]> {
        let res = await this.getRooms();
        // admin can see everything
        if (!roles.includes(USER_ROLES.Admin)) {
            res = res.filter(x => roles.includes(x.role_name));
        }
        return res;
    }
}
